<div class="checkbox-field" [ngClass]="{ 'has-error': hasError, center: center }">
  <input
    #field
    type="checkbox"
    [name]="name"
    [id]="id"
    class="checkbox-element"
    [ngClass]="{ white: white }"
    [formControl]="control"
    [indeterminate]="isIndeterminate"
    value="{{ control.value }}"
  />

  <span class="checkbox-visual">
    <i
      class="fas"
      [ngClass]="{
        'fa-check': !hasError && !isIndeterminate && control.value,
        'fa-times': hasError,
        'fa-minus': !hasError && isIndeterminate
      }"
    ></i>
  </span>

  <label *ngIf="label" for="{{ id }}" class="checkbox-label">{{ label }}</label>
</div>
